import React, { createContext, useCallback, useContext, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import { Box, IconButton, Slide, type SlideProps, Snackbar, Typography } from '@mui/material'

interface AlertContextType {
  showAlert: (message: string) => void
}

const AlertContext = createContext<AlertContextType>({ showAlert: () => { } })

export const useAlert = () => useContext(AlertContext)

const SlideDown = (props: SlideProps) => <Slide {...props} direction="down" />

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')

  const showAlert = useCallback((msg: string) => {
    setMessage(msg)
    setOpen(true)
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={SlideDown}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 360,
            px: 10,
            py: 8,
            borderRadius: 3,
            backgroundColor: '#FFF8E1',
            color: '#663C00',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
            border: '1px solid #FFE082',
          }}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 28, color: '#E6A700' }} />
          <Typography sx={{ flex: 1, fontSize: 15, fontWeight: 500 }}>
            {message}
          </Typography>
          <IconButton onClick={handleClose} size="small" sx={{ color: '#663C00', opacity: 0.7, '&:hover': { opacity: 1 } }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Snackbar>
    </AlertContext.Provider>
  )
}
